import React, { useState, useEffect } from "react"
import { Container, Card, CardBody } from "reactstrap"
import axios from "axios"
import Spinners from "components/Common/Spinner"
import { Link } from "react-router-dom"
import moment from "moment/moment"
import { replaceS3Url } from "components/Common/ReplaceS3Url"

const DateCard = ({
  id,
  description,
  name,
  file_location,
  staff_name,
  out_of_marks,
  file_name,
  date,
  subject,
  remarks,
  submitted_assign,
}) => {
  return (
    <Link
      to={`/submit-assignment/${id}`}
      state={{
        id: id,
        description: description,
        date: date,
        name: name,
        file_location: file_location,
        staff_name: staff_name,
        out_of_marks: out_of_marks,
        file_name: file_name,
        subject: subject,
        submitted_assign: submitted_assign,
        remarks: remarks,
      }}
    >
      <Card className="mb-3">
        <CardBody>
          <div className="d-flex flex-row justify-content-between align-items-center">
            <span className="mt-3 fs-5 text-start">Subject:</span>
            <span className="mt-1 fs-5 text-dark fw-medium">{subject}</span>
          </div>
          <div className="d-flex flex-row justify-content-between align-items-center">
            <span className="mt-3 fs-5 text-start">Date:</span>
            <span className="mt-1 fs-5 text-dark fw-medium">
              {moment(date).format("DD-MM-YYYY")}
            </span>
          </div>
        </CardBody>
      </Card>
    </Link>
  )
}

function getFullFileUrl(location, file) {
  const baseUrl = replaceS3Url(location);
  const fileName = file;

  const fileExtensions = ['.jpg', '.jpeg', '.png', '.pdf', '.docx', '.xlsx'];

  const hasFileExtension = fileExtensions.some(ext => baseUrl.toLowerCase().endsWith(ext));

  if (hasFileExtension) {
    return baseUrl; 
  } else {
    return baseUrl.endsWith('/') ? baseUrl + fileName : baseUrl + '/' + fileName;
  }
}


const AssignmentDetails = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])

  const getStudentAssignment = async () => {
    try {
      setLoading(true)
      const resp = await axios.post(
        "https://topschool.prisms.in/rest/index.php/staff_list.json",
        {
          fun_name: "getStudentAssignment",
          sid: localStorage.getItem("sid").replace(/"/g, ""),
          user_id: localStorage.getItem("user_id"),
        }
      )
      const grouped = []

      resp.data.records &&
        resp.data.records.forEach(item => {
          const existing = grouped.find(g => g.id === item.id)

          if (existing) {
            existing.files.push(item.submitted_assign)
          } else {
            grouped.push({
              id: item.id,
              name: item.name,
              date: item.date,
              subject: item.subject,
              staff_name: item.staff_name,
              description: item.description,
              file_location: getFullFileUrl(item.file_location, item.file_name),
              files: [item.submitted_assign ],
              remarks: item.remarks,
              out_of_marks: item.out_of_marks,
              file_name: item.file_name,
              status_is_publish: item.status_is_publish,
            })
          }
        })

      setData(grouped)
    } catch (error) {
      console.error("Error fetching assignments:", error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getStudentAssignment()
  }, [])


  return (
    <div className="page-content px-0 bg-white" style={{ paddingTop: "90px" }}>
      <Container>
        <Card>
          <CardBody>
            <h1 className="text-center mb-4 fs-3" style={{ color: "#3c3c3c" }}>
              Assignment
            </h1>
            {loading ? (
              <Spinners />
            ) : data && data.length > 0 ? (
              data.map((item, index) => (
                <React.Fragment key={item.id}>
                  {item.status_is_publish === "1" && (
                    <DateCard
                      id={item.id}
                      description={item.description}
                      name={item.name}
                      file_location={item.file_location}
                      date={item.date}
                      staff_name={item.staff_name}
                      out_of_marks={item.out_of_marks}
                      remarks={item.remarks}
                      subject={item.subject}
                      file_name={item.file_name}
                      submitted_assign={item.files}
                    />
                  )}
                </React.Fragment>
              ))
            ) : (
              <Card>
                <CardBody>
                  <h5 className="text-center text-muted">
                    No assignments available.
                  </h5>
                </CardBody>
              </Card>
            )}
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

export default AssignmentDetails
